import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "save", "view", "list", "content", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--financials--index--receivables--dashboard`
    this.receivablesLoaded = false
  }

  doReceivablesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-12 px-0" data-${this.controllerName}-target="content" data-controller="operations--products--clinics--financials--index--receivables--list
                                                                                                         operations--products--clinics--financials--index--receivables--save
                                                                                                         operations--products--clinics--financials--add--show"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--financials--index--dashboard").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--products--clinics--financials--index--dashboard").contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--financials--index--submenu`).dashboardToggleBtn(`NOTA FISCAL`)

      controller.getControllerByIdentifier(`operations--products--clinics--financials--index--receivables--save`).permission = `medclinic_financial_receivables`

      controller.getControllerByIdentifier(`operations--products--clinics--financials--add--show`).permission = `medclinic_financial_receivables`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--add--show`).integration_permission = `medclinic_financial_integration_invoices`

      controller.getControllerByIdentifier(`operations--products--clinics--financials--index--receivables--list`).permission = `medclinic_financial_receivables`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--index--receivables--list`).doIndexListHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
